exports.General = {
  logoPath: '/img/general/logo.png',
  logoPathBlue: '/img/general/hackhub-logo-blue.png',
  allNav: '/img/general/all_icon.png',
  ownNav: '/img/general/own_icon.png',
  joinNav: '/img/general/join_icon.png',
  hackhubLink: '/',
  notFound: '/img/general/404.png',
  accountIcon: '/img/general/account.png',
  dashboardIcon: '/img/general/dashboard.png',
  chatIcon: '/img/general/chat.png',
  eventsIcon: '/img/general/events.png',
  logoutIcon: '/img/general/logout.png',
  mentorsIcon: '/img/general/mentors.png'
};

exports.Company = {
  defaultNavIcon: '/img/company/navLogo.png',
  addIcon: '/img/company/add.png'
};

exports.Project = {
  defaultLogo: '/img/p_profile/upload.png',
  createNew: '/img/project/create_new.png',
  defaultBackground: '/img/project/default_project.jpg',
  defaultSubmissionBackground: '/img/general/icon_grid-07.png',
  defaultCoverImage: '/img/cms/coverimage3.jpg'
};

exports.ProjectView = {
  ALL: 'all',
  OWN: 'own',
  JOIN: 'join'
};

exports.ProjectStatus = {
  OWN: 'OWN',
  NOT_JOINED: 'NOT_JOINED',
  JOINED: 'JOINED'
};

exports.User = {
  defaultAvatar: '/img/user/profile.png',
  defaultNavIcon: '/img/user/profile.png',
  logoutNav: '/img/user/logout.png'
};

exports.SNS = {
  FACEBOOK_ACTIVE: '/img/social/facebook.png',
  GITHUB_ACTIVE: '/img/social/github.png',
  BEHANCE_ACTIVE: '/img/social/behance.png',
  INSTAGRAM_ACTIVE: '/img/social/instagram.png',
  DRIBBBLE_ACTIVE: '/img/social/dribbble.png',
  TWITTER_ACTIVE: '/img/social/twitter.png',
  FLICKR_ACTIVE: '/img/social/flickr.png',
  YOUTUBE_ACTIVE: '/img/social/youtube.png',
  VIMEO_ACTIVE: '/img/social/vimeo.png',
  PINTEREST_ACTIVE: '/img/social/pinterest.png',
  LINKEDIN_ACTIVE: '/img/social/linkedin.png',

  FACEBOOK_PREFIX: 'https://www.facebook.com/',
  GITHUB_PREFIX: 'https://github.com/',
  BEHANCE_PREFIX: 'https://www.behance.net/',
  INSTAGRAM_PREFIX: 'https://www.instagram.com/',
  DRIBBBLE_PREFIX: 'https://dribbble.com/',
  TWITTER_PREFIX: 'https://twitter.com/',
  FLICKR_PREFIX: 'https://www.flickr.com/people/',
  YOUTUBE_PREFIX: 'https://www.youtube.com/user/',
  VIMEO_PREFIX: 'https://www.vimeo.com/',
  PINTEREST_PREFIX: 'https://www.pinterest.com/',
  LINKEDIN_PREFIX: 'https://www.linkedin.com/in/'
};

exports.REGEX = {
  USERNAME: '^[a-zA-Z0-9_]+$',
  EMAIL: '^([w_.-+])+@([w-]+.)+([w]{2,10})+$'
};

exports.ALERT_TYPE = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};

const S3ImageFolder = 'https://cdn.hackhub.com/images';

// exports.BANNER_TEMPLATE = {
//   bannerOne: `${S3ImageFolder}/templates/template-1-banner.jpg`,
//   bannerTwo: `${S3ImageFolder}/templates/templateBanner2.jpg`,
//   bannerThree: `${S3ImageFolder}/templates/template-2-banner.jpg`,
//   bannerFour: `${S3ImageFolder}/templates/template-3-banner.jpg`,
//   bannerFive: `${S3ImageFolder}/templates/template-4-banner.jpg`,
//   bannerSix: `${S3ImageFolder}/templates/template-5-banner.jpg`,
//   bannerTrigger: `${S3ImageFolder}/templates/bannerImgTrigger.jpg`,

//   coverOne: `${S3ImageFolder}/templates/template-1-cover.jpg`,
//   coverTwo: `${S3ImageFolder}/templates/templateCover2.jpg`,
//   coverThree: `${S3ImageFolder}/templates/template-2-cover.jpg`,
//   coverFour: `${S3ImageFolder}/templates/template-3-cover.jpg`,
//   coverFive: `${S3ImageFolder}/templates/template-4-cover.jpg`,
//   coverSix: `${S3ImageFolder}/templates/template-5-cover.jpg`,
//   coverTrigger: `${S3ImageFolder}/templates/coverImgTrigger.jpg`
// };

// exports.BANNER_TEMPLATE = {
//   bannerOne: '/img/event/event-templates/template-1-banner.jpeg',
//   bannerTwo: '/img/event/event-templates/template-2-banner.jpeg',
//   bannerThree: '/img/event/event-templates/template-3-banner.jpeg',
//   bannerFour: '/img/event/event-templates/template-4-banner.jpeg',
//   bannerFive: '/img/event/event-templates/template-5-banner.jpeg',
//   bannerSix: '/img/event/event-templates/template-6-banner.jpeg',
//   bannerTrigger: `${S3ImageFolder}/templates/bannerImgTrigger.jpg`,

//   coverOne: '/img/event/event-templates/template-1-cover.jpeg',
//   coverTwo: '/img/event/event-templates/template-2-cover.jpeg',
//   coverThree: '/img/event/event-templates/template-3-cover.jpeg',
//   coverFour: '/img/event/event-templates/template-4-cover.jpeg',
//   coverFive: '/img/event/event-templates/template-5-cover.jpeg',
//   coverSix: '/img/event/event-templates/template-6-cover.jpeg',
//   coverTrigger: `${S3ImageFolder}/templates/coverImgTrigger.jpg`
// };

exports.BANNER_TEMPLATE = {
  bannerOne: 'templates/eventBanner/template-1-banner.jpeg',
  bannerTwo: 'templates/eventBanner/template-2-banner.jpeg',
  bannerThree: 'templates/eventBanner/template-3-banner.jpeg',
  bannerFour: 'templates/eventBanner/template-4-banner.jpeg',
  bannerFive: 'templates/eventBanner/template-5-banner.jpeg',
  bannerSix: 'templates/eventBanner/template-6-banner.jpeg',
  bannerTrigger: `${S3ImageFolder}/templates/bannerImgTrigger.jpg`,

  coverOne: 'templates/eventCover/template-1-cover.jpeg',
  coverTwo: 'templates/eventCover/template-2-cover.jpeg',
  coverThree: 'templates/eventCover/template-3-cover.jpeg',
  coverFour: 'templates/eventCover/template-4-cover.jpeg',
  coverFive: 'templates/eventCover/template-5-cover.jpeg',
  coverSix: 'templates/eventCover/template-6-cover.jpeg',
  coverTrigger: `${S3ImageFolder}/templates/coverImgTrigger.jpg`
};


exports.BingMap = {
  key: 'AgkJu8xe2tNYUKVGT7nRYydQ9bLqJNKqoGLxgahuOaMcOOK6Oa82EIPQFI0d4NIE'
};



// WEBPACK FOOTER //
// ./src/components/common/constant.js